module.exports = __webpack_public_path__ + "static/media/Matheson Street, Healdsburg, CA4.ae876965.jpg";